/**
 * Shared category-icon + tint mapping for chores. Mirrors iOS
 * `Views/Chores/ChoresView.swift` `categoryIcon`/`categoryColor` and
 * Android `ChoreCategoryIcon` (drawable lookup). Kept identical
 * across surfaces so the same chore looks the same on the Chores
 * list, Choreboard, dashboard cards, etc.
 */

export interface ChoreCategoryMeta {
  icon: string;
  color: string;
}

export const CHORE_CATEGORY_META: Record<string, ChoreCategoryMeta> = {
  kitchen: { icon: "\u{1F374}", color: "bg-orange-500" },
  bathroom: { icon: "\u{1F6BF}", color: "bg-cyan-500" },
  bedroom: { icon: "\u{1F6CF}️", color: "bg-indigo-500" },
  yard: { icon: "\u{1F33F}", color: "bg-green-500" },
  pets: { icon: "\u{1F43E}", color: "bg-amber-700" },
  laundry: { icon: "\u{1F455}", color: "bg-purple-500" },
  general: { icon: "\u{1F3E0}", color: "bg-gray-500" },
};

export function choreCategoryMeta(cat?: string | null): ChoreCategoryMeta {
  return CHORE_CATEGORY_META[cat ?? "general"] ?? CHORE_CATEGORY_META.general;
}
